<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp
      ref="snackbar"
      v-bind:mesaj="text1"
      v-model="snackbar"
    ></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t("Accounting-Code") }} </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tooltip bottom v-if="this.$route.query.islem == 'new'">
              <v-btn
                slot="activator"
                :disabled="!sayfayetki.Save"
                @click="addAccoutingCode(2)"
                flat
              >
                <span class="hidden-sm-and-down"> {{ $t("Add") }} </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{
                $t("Limited-Authorization")
              }}</span>
              <span v-if="sayfayetki.Save">{{ $t("Add") }} </span>
            </v-tooltip>

            <v-tooltip bottom v-if="this.$route.query.islem == 'get'">
              <v-btn
                slot="activator"
                :disabled="!sayfayetki.Update"
                @click="updateAccoutingCode()"
                flat
              >
                <span class="hidden-sm-and-down"> {{ $t("Update") }} </span>
                <v-icon right dark>system_update_alt</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Update">{{
                $t("Limited-Authorization")
              }}</span>
              <span v-if="sayfayetki.Update">{{ $t("Update") }}</span>
            </v-tooltip>

            <v-menu offset-y v-if="this.$route.query.islem == 'get'">
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="deleteAccount()">
                  <v-list-tile-title>
                    {{ $t("Delete-Account") }}
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-flex>

        <v-flex xs12 sm12 md12>
          <v-tabs
            style="width: 100%"
            dark=""
            v-model="modelActive"
            color="blue darken-3"
            slot="extension"
            slider-
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#0">
              {{ $t("tab_general") }}
            </v-tab>
            <v-tab-item :id="'0'" style="width: 100%" class="pa-3">
              <v-card light style="max-height: 575px">
                <v-card-text>
                  <v-layout row="" wrap="">
                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap>
                        <!-- <v-flex xs12 sm12 md4>
                          <v-layout row wrap>
                            <v-flex xs12 sm12 md4>
                              <v-switch
                                v-model="accoutingCode.RootCode"
                                @change="RootChange(accoutingCode.RootCode)"
                                hide-details
                                :label="$t('Main-Account-v2')"
                                class="shrink mr-2"
                              ></v-switch>
                            </v-flex>
                            <v-flex xs12 sm12 md8>
                              <catimuhasebekodu
                                :islem="this.$route.query.islem"
                                :aktifmi="accoutingCode.RootCode"
                                v-model="accoutingCode.MainCodeInfo"
                                :controlValue="accoutingCode.MainCodeInfo.Code"
                                :companyID="this.$route.query.CompanyID"
                                :text="$t('Main-Accounting-Code')"
                              >
                              </catimuhasebekodu>
                            </v-flex>
                          </v-layout>
                        </v-flex> -->
                        <v-flex xs12 sm12 md6>
                          
                          <Muhasebekodu
                            v-model="accoutingCode.Code"
                            :tip="this.$route.query.islem"
                            :aktifmi="isUpdate"
                            @addAccoutingCode="addAccoutingCode(2)"
                            @updateAccoutingCode="updateAccoutingCode()"
                          ></Muhasebekodu>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                          <v-text-field
                            :label="$t('Accounting-Name')"
                            v-model="accoutingCode.CodeName"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md4>
                          <v-text-field
                            :label="$t('Alternative-Accounting-Code')"
                            v-model="accoutingCode.AlternativeCode"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-text-field
                            :label="$t('Alternative-Accounting-Name')"
                            v-model="accoutingCode.AlternativeCodeName"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-select
                            :label="$t('Account-Group-v2')"
                            v-model="accoutingCode.AccountGroup"
                            item-text="Adi"
                            item-value="Kod"
                            :items="hesapitems"
                            mask="AA"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>

              <v-card class="mt-3" light style="max-height: 575px">
                <v-card-text>
                  <v-layout row="" wrap="">
                    <v-flex xs12 sm12 md4>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                          <caricomp
                            v-bind:zorunlumu="false"
                            v-model="accoutingCode.AccountCodeInfo.Kod"
                          ></caricomp>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm12 md8>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md4>
                          <v-select
                            :label="$t('Currency')"
                            :items="doviztipi"
                            item-text="Title"
                            item-value="DovizKod"
                            clearable
                            v-model="accoutingCode.Currency"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-select
                            :label="$t('Balance')"
                            :items="balanceTypeList"
                            item-text="text"
                            item-value="value"
                            v-model="accoutingCode.BalanceType"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-switch
                            :label="$t('Reference-Required')"
                            v-model="accoutingCode.ReferanceForced"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-switch
                            :label="$t('Currency-Account')"
                            v-model="accoutingCode.ForeignCurrencyCode"
                          ></v-switch>
                        </v-flex>

                        <v-flex xs12 sm12 md4>
                          <v-switch
                            :label="$t('Passify-the-Account')"
                            @change="
                              activePassive(accoutingCode.CodeActivePassive)
                            "
                            v-model="accoutingCode.CodeActivePassive"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-switch
                            @change="lockedAccount(accoutingCode.CodeLocked)"
                            :label="$t('Lock-Account')"
                            v-model="accoutingCode.CodeLocked"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-switch
                            :label="$t('Expense-Center-Obligatory')"
                            v-model="accoutingCode.CostCenterForced"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-switch
                            label="Tevkifat Hesabı"
                            v-model="accoutingCode.WithHoldingAccount"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs12 sm12 md4 v-if="this.accoutingCode.WithHoldingAccount == true"> 
                          <v-text-field
                            label="Tevkifat Kod"
                            v-model="accoutingCode.WithHoldingCode"
                            maxlength="3" 
                            required  :rules="[rules.required]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md4
                          v-if="accoutingCode.CodeActivePassive"
                        >
                          <tarihim
                            :v-bind="accoutingCode.ActivePassiveDate"
                            v-model="accoutingCode.ActivePassiveDate"
                            :etiket="$t('Active-Passive-Date')"
                            :aktifmi="true"
                          >
                          </tarihim>
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md4
                          v-if="!accoutingCode.CodeActivePassive"
                        >
                        </v-flex>
                      
                        <v-flex xs12 sm12 md4 v-if="accoutingCode.CodeLocked">
                          <v-flex xs12 sm12 md12>
                            <tarihim
                              :v-bind="accoutingCode.LockedDate"
                              v-model="accoutingCode.LockedDate"
                              :etiket="$t('Lockdown-Date')"
                              :aktifmi="true"
                            >
                            </tarihim>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <v-flex
                          xs12
                          sm12
                          md12
                          v-if="this.accoutingCode.WithHoldingAccount == false"
                        >
                        <v-card>
                          <v-card-text>
                  <v-layout row="" wrap="">
                    <v-autocomplete
  label="İlişkili Tevkifat Hesapları"
  :items="tevkifatHesapItems"
  multiple
  hide-details="" item-text="Code" item-value="CodeID" 
  v-model="accoutingCode.RelatedWithHoldingCodes" return-object
></v-autocomplete>
                   

                  </v-layout>
                
                </v-card-text>
                        </v-card>
                       
                        </v-flex>
            </v-tab-item>

            <v-tab href="#1" v-if="this.$route.query.islem == 'get'">
              Geçmiş
            </v-tab>
            <v-tab-item
              :id="'1'"
              v-if="this.$route.query.islem == 'get'"
              style="width: 100%"
            >
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm12 md12>
                  <v-card flat>
                    <v-data-table
                      :headers="headersLog"
                      :rows-per-page-items="[50, 100]"
                      :items="accoutingCode.LogList"
                    >
                      <template slot="items" slot-scope="props">
                        <tr item>
                          <td class="text-xs-left">
                            {{ props.item.UserName }}
                          </td>
                          <td class="text-xs-left">
                            {{ props.item.ProcessDescription }}
                          </td>
                          <td class="text-xs-left">
                            {{ props.item.ProcessDate | dateformat }}
                            {{ props.item.ProcessDate | timeformat }}
                          </td>
                          <td class="text-xs-left">
                            <v-icon
                              @click="openProcces(props.item.ProcessText)"
                            >
                              search</v-icon
                            >
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-card>

    <v-dialog v-model="LogRequest" max-width="400px">
      <v-card>
        <v-card-title> {{ $t("Request-Detail") }} </v-card-title>
        <v-card-text>{{ LogRequestData }}</v-card-text>
        <v-card-actions
          ><v-btn @click="LogRequest = false">
            {{ $t("Close") }}
          </v-btn></v-card-actions
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "@/api/auth";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import catimuhasebekodu from "../comp/catimuhasebekodu.vue";
import caricomp from "@/components/app/customcomp/caricomp.vue";
import Muhasebekodu from "../comp/muhasebekodu.vue";

export default {
  data() {
    return {
      rules: {
                required: (value) => !!value || this.$t('Mandatory-Areas'),
                email: (value) => {
                    const pattern =
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('Wrong-e-mail')
                }
            },
      selectedTevkifats:[],
      LogRequest: false,
      LogRequestData: null,
      headersLog: [
        {
          text: this.$t("User"),
        },
        {
          text: this.$t("Process"),
        },
        {
          text: this.$t("Transaction-Date"),
        },
        {
          text: this.$t("Transaction-details"),
        },
      ],
      accoutingCode: {
        UserID: 0,
        CodeID: 0,
        CompanyID: 0,
        MainCodeInfo: {
          CodeID: 0,
          CompanyID: 0,
          Code: null,
          CodeName: null,
         
        },
        Code: null,
        CodeName: null,
        AccountGroup: null,
        AccountCodeInfo: {
          SirketKodu: 0,
          Kod: null,
          Unvan: null,
          Unvani2: null,
          MuhasebeKodu: null,
          VergiDaire: null,
          VergiNo: null,
          TCNo: null,
        },
        ForeignCurrencyCode: false,
        Currency: null,
        BalanceType: 0, //0 : tüm 1: alacak 2:borç
        CodeActivePassive: false,
        ActivePassiveDate: null,
        ActivePassiveUserID: 0,
        CodeLocked: false,
        LockedDate: null,
        LockedUserID: 0,
        AlternativeCode: null,
        AlternativeCodeName: null,
        ReferanceForced: false,
        CostCenterForced: false,
        RootCode: false,
        SectionCodeForced: false,
        SavedDate: null,
        SavedUserID: 0,
        Deleted: false,
        DeletedDate: null,
        DeletedUserId: null,
        LogList: [],
        WithHoldingAccount: false,
        WithHoldingCode: "",
        RelatedWithHoldingCodes: []
      },
      balanceTypeList: [
        {
          text: "Tüm",
          value: 0,
        },
        {
          text: this.$t("Credit"),
          value: 1,
        },
        {
          text: this.$t("Debit"),
          value: 2,
        },
      ],
      tevkifatHesapItems:[],
      hesapitems: [],
      doviztipi: [],
      modelActive: null,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      isUpdate: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      loadData: {
        UserID: 0,
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        SearchText: null,
      },
    };
  },
  methods: {
    cleanAllData() {
      var accoutingCode = {
        UserID: 0,
        CodeID: 0,
        CompanyID: 0,
        MainCodeInfo: {
          CodeID: 0,
          CompanyID: 0,
          Code: null,
          CodeName: null,
        },
        Code: null,
        CodeName: null,
        AccountGroup: null,
        AccountCodeInfo: {
          SirketKodu: 0,
          Kod: null,
          Unvan: null,
          Unvani2: null,
          MuhasebeKodu: null,
          VergiDaire: null,
          VergiNo: null,
          TCNo: null,
        },
        ForeignCurrencyCode: false,
        Currency: null,
        BalanceType: 0, //0 : tüm 1: alacak 2:borç
        CodeActivePassive: false,
        ActivePassiveDate: null,
        ActivePassiveUserID: 0,
        CodeLocked: false,
        LockedDate: null,
        LockedUserID: 0,
        AlternativeCode: null,
        AlternativeCodeName: null,
        ReferanceForced: false,
        CostCenterForced: false,
        RootCode: false,
        SectionCodeForced: false,
        SavedDate: null,
        SavedUserID: 0,
        Deleted: false,
        DeletedDate: null,
        DeletedUserId: null,
        LogList: [],
      };

      this.accoutingCode = accoutingCode;
    },
    RootChange(val) {
      if (val == true) {
        var MainCodeInfo = {
          CodeID: 0,
          CompanyID: 0,
          Code: null,
          CodeName: null,
        };
        this.accoutingCode.MainCodeInfo = MainCodeInfo;
      }
    },
    getHesapKodu() {
      var params = {
        CompanyCode: this.credentials.MuhasebeSirketNo,
      };
      this.$http
        .post(auth.API_URL + "api/Definitions/CurrentGroupList", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.hesapitems = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            }
          }
        );
    },
    activePassive(val) {
      this.accoutingCode.CodeActivePassive = val;
      this.accoutingCode.ActivePassiveUserID = this.credentials.UserID;
      if (this.$route.query.islem == "get") {
        this.addAccoutingCode(1);
      }
    },
    lockedAccount(val) {
      this.accoutingCode.CodeLocked = val;
      this.accoutingCode.LockedUserID = this.credentials.UserID;
      if (this.$route.query.islem == "get") {
        this.addAccoutingCode(1);
      }
    },
    deleteAccount() {
      this.loadingvmodel = true;
      var params = {
        UserID: this.credentials.UserID,
        CodeID: this.$route.query.CodeID,
        CompanyID: this.credentials.MuhasebeSirketNo,
        Code: null,
        SearchText: null,
      };
      this.$http
        .post(
          auth.API_URL + "api/AccountingCodes/AccountingCodeDelete",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            if (response.body.Status) {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.loadingvmodel = false;
              setTimeout(
                function () {
                  this.sendListPage();
                }.bind(this),
                1000
              );
            } else {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCodeDelete";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-AccountingCodeDelete";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    sendListPage() {
      var url = "#/muhasebe/muhasebekodlari/liste";
      window.open(url, "_self");
    },
    openProcces(dialogText) {
      this.LogRequest = true;
      this.LogRequestData = dialogText;
    },
    updateAccoutingCode() {
      this.addAccoutingCode(2);
    },
    getAccountData() {
      this.loadingvmodel = true;
      this.loadData.UserID = this.credentials.UserID;
      this.loadData.CompanyID = this.$route.query.CompanyID;
      this.loadData.CodeID = this.$route.query.CodeID;
      this.loadData.Code = this.$route.query.Code;
      this.$http
        .post(
          auth.API_URL + "api/AccountingCodes/AccountingCodeLoad",
          this.loadData,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.accoutingCode = response.body;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCodeLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-AccountingCodeLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    loadtevkifatHesapKodlari() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params1 = {
        UserID: 0,
          CodeID: 0,
          CompanyID:credentials.MuhasebeSirketNo,
          Code: null,
          SearchText: '',
          BalanceShow: false,
          OnlyWithHoldingAccounts:true
      };

      this.$http
        .post(
          auth.API_URL + "api/AccountingCodes/AccountingCodeList",
          params1,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {


            for (let index = 0; index < response.body.length; index++) {
                  const element = response.body[index];
                  this.tevkifatHesapItems.push(
                   
                   
                 element

                   
                    
                  );
                 
                }
            
          },
            
            
         
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCodeList";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-AccountingCodeList";
              this.snackbar = true;
            }
          }
        );
    },
    addAccoutingCode(yonlendirme) {
      this.loadingvmodel = true;
      if (this.accoutingCode.WithHoldingAccount==true)
      {
        this.accoutingCode.RelatedWithHoldingCodes=[];
      }

      this.accoutingCode.UserID = this.credentials.UserID;
      this.accoutingCode.CompanyID = this.credentials.MuhasebeSirketNo;
      this.accoutingCode.SavedUserID = this.credentials.UserID;
      this.$http
        .post(
          auth.API_URL + "api/AccountingCodes/AccountingCodeSave",
          this.accoutingCode,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            if (response.body.Status) {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.loadingvmodel = false;
              if (yonlendirme == 2) {
                setTimeout(
                  function () {
                    this.cleanAllData();
                  }.bind(this),
                  1500
                );
              } else {
                this.getAccountData();
              }
            } else {
              let data = {
                response: {},
                request: {},
                api: "AccountingCodeSave",
                type: 2,
                message: response.body.ResponseMessage,
              };
              this.$refs.snackbar.open(data);
              this.loadingvmodel = false;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCodeSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-AccountingCodeSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    gitUpdate(Code) {
      var url =
        "#/muhasebe/muhasebekodlari/islem/id?" +
        "islem=get&Code=" +
        this.accoutingCode.Code +
        "&CompanyID=" +
        this.credentials.MuhasebeSirketNo +
        "&CodeID=" +
        Code;
      window.open(url, "_self");
      window.reload();
    },
    getCurrency() {
      var params = {
        CompanyCode: this.credentials.SirketKodu,
      };

      this.$http
        .post(auth.API_URL + "api/currency/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.doviztipi = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            }
          }
        );
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    caricomp,
    tarihim,
    catimuhasebekodu,
    Muhasebekodu,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      this.getCurrency();
      this.getHesapKodu();
      this.loadtevkifatHesapKodlari();
      // eslint-disable-next-line no-empty
      if (this.$route.query.islem == "new") {
      } else {
        this.isUpdate = true;
        this.getAccountData();
      }
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          }
        });
    }
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
    timeformat: function (t) {
      return helpers.getTime(t);
    },
  },
};
</script>

<style>
</style>
